import styled from 'styled-components';
import {
  margin,
  padding,
  layout,
  LayoutProps,
  MarginProps,
  PaddingProps,
  JustifyContentProps,
  justifyContent,
} from 'styled-system';

export const Box = styled.div<
  MarginProps & PaddingProps & LayoutProps & JustifyContentProps
>`
  ${margin};
  ${padding};
  ${layout};
  ${justifyContent};
`;
